// extracted by mini-css-extract-plugin
export default {"communities":"Communities_communities__NU4KH"};